import { Link } from 'react-router';
import lobo from './lobo_pl_cropped.png';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer__inner">
                <Link className="footer__brand" to="/" aria-label="Lobo Powerlifting home">
                    <img src={lobo} alt="" />
                    <span>Lobo Powerlifting</span>
                </Link>
                <p>© 2025 University of New Mexico Lobo Powerlifting</p>
                <a className="footer__social" href="https://www.instagram.com/lobo.powerlifting" target="_blank" rel="noreferrer" aria-label="Lobo Powerlifting on Instagram">
                    <img src="/images/instagram-white-icon.webp" alt="" />
                </a>
            </div>
        </footer>
    );
}

export default Footer;
